import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, And, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';

@Injectable({ providedIn: 'root' })
export class ABBranchService extends AutomationDisplayService {
  constructor(protected readonly translateService: TranslateService) {
    super();
  }

  /** Gets text for the activity column in the table. */
  getActivityColumn(_namespace: string, activity: ActivityInterface): ActivityTableEntry {
    if (activity?.error) {
      return this.tableEntry(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.AB_BRANCH.ACTIVITY.FAILURE'),
        this.emptyBody(),
      );
    }

    const nextStepId = activity?.nextWorkflowStep?.id;
    const executedStep = activity?.workflowStep;
    let displayContent = 'AUTOMATIONS.EDITOR.TASKS.AB_BRANCH.ACTIVITY.CONTINUED_ON_A';

    if (executedStep.choices?.defaultNextStep === nextStepId) {
      displayContent = 'AUTOMATIONS.EDITOR.TASKS.AB_BRANCH.ACTIVITY.CONTINUED_ON_B';
    }

    // Show user-friendly text if the step proceeded
    return this.tableEntry(this.translateService.stream(displayContent), this.emptyBody());
  }

  /** The text in an automation node (i.e. the nodes in the graph). */
  getAutomationNodeData(
    _namespace: string,
    step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    let aBranchValue = 0;
    if (step.choices?.rules?.length > 0) {
      const and = And.fromRuleInterface(step.choices?.rules[0]);
      const aBranchRule = and.listValuesByVariablePath('aBranchCondition');
      if (!!aBranchRule && aBranchRule.length > 0) {
        aBranchValue = +aBranchRule[0];
      }
    }

    if (aBranchValue >= 0 || aBranchValue <= 100) {
      const bBranchValue = 100 - +aBranchValue;
      return this.nodeDisplayData(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.AB_BRANCH.ACTION.TITLE', {
          branch_a_value: aBranchValue,
          branch_b_value: bBranchValue,
        }),
        this.noValidationErrorsDetected(),
      );
    }

    return this.nodeDisplayData(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.AB_BRANCH.TITLE'),
      this.validationErrorsDetected(
        step,
        this.translateService.instant('AUTOMATIONS.EDITOR.TASKS.AB_BRANCH.ACTION.CONFIG_ERROR'),
        true,
      ),
    );
  }
}
